// extracted by mini-css-extract-plugin
export default {"container":"kuDELt7E","card":"wJUcRLjk","header":"a970VhWQ","title":"rwT16CMt","label":"rB5DqELs","name":"xrmLvZCD","buttons":"ZXDSrtwI","form":"FwePrmh7"};